import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'
import { OPERATION_PATH, addOperation } from '../../api/operationApi'
import { addOperationAction } from '../../redux/feature/operationSlice'

const OperationSubmitPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [newOperation, setNewOperation] = useState({
        code: "",
        name: "",
        description: ""
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('post', `${OPERATION_PATH}`, true)

    const onClickSubmit = () => {
        addOperation(newOperation)
            .then(res => {
                dispatch(addOperationAction(res.data))
                closeTab()
                toast.success('Desen kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni İşlem</label>
                <Input
                    label='İşlem Kodu'
                    name='code'
                    placeholder='İşlem kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setNewOperation, setErrors)}
                />
                <Input
                    label='İşlem Adı'
                    name='name'
                    placeholder='İşlem adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setNewOperation, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setNewOperation, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default OperationSubmitPage